//
import Model from '@/models/Model'

/**
 * This class describes a g print job dispatch request.
 * @class GPrintJobDispatchRequest (name)
 */
export default class GPrintJobDispatchRequest extends Model {

	/**
	 * { function_description }
	 * @return {string} { description_of_the_return_value }
	 */
  resource() {
    return 'g_print_job_dispatch_request'
  }
}
